import { createAsyncThunk } from '@reduxjs/toolkit';

export const pullProductsForSalesChannel = createAsyncThunk(
  'salesChannels/pullProductsForSalesChannel',
  async ({ salesChannelId }, { extra: { sdk, Logger } }) => {
    try {
      await sdk.products.pullAll(salesChannelId);
      return { salesChannelId };
    } catch (error) {
      Logger.error(
        new Error('Pull products for sales channel failed'),
        { error, salesChannelId },
        ['ConnectShopifyChPullFailed', { salesChannelId: String(salesChannelId) }],
      );
      throw error;
    }
  },
);
